import { render } from "./CurrForm.vue?vue&type=template&id=8cc5d53e"
import script from "./CurrForm.vue?vue&type=script&lang=js"
export * from "./CurrForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__